import React from "react";
import CertificateSelect from "components/common/DownloadCertificate/CertificateSelect";
import DownloadCertificateButton from "components/common/DownloadCertificate/DownloadCertificateButton";
import { CourseIntersection } from "./types";

interface CourseCompletedProps {
  course: CourseIntersection;
  courseRefetchHandler: () => void;
}

const CourseCompleted = ({ course, courseRefetchHandler }: CourseCompletedProps) => {
  const eventId = course.event?.id;
  const userEventDetails = course.event?.userEventDetails;
  const certificateChoiceRequired =
    userEventDetails?.isLiveCeAwardable && !userEventDetails?.certificateId;

  return (
    <div>
      <h1 className="text-5xl">Congratulations!</h1>
      <p className="text-2xl my-5">
        You have completed <strong>{course.title}</strong>.
      </p>
      {course.id &&
        (eventId && certificateChoiceRequired ? (
          <CertificateSelect eventId={eventId} courseRefetchHandler={courseRefetchHandler} />
        ) : (
          <DownloadCertificateButton courseOrProgramId={course.id} />
        ))}
    </div>
  );
};

export default CourseCompleted;
